__turbopack_context__.v({
  "card": "ScrollReveal-module__Jsyyca__card",
  "scrollCardReveal": "ScrollReveal-module__Jsyyca__scrollCardReveal",
  "scrollSkillReveal": "ScrollReveal-module__Jsyyca__scrollSkillReveal",
  "scrollStaggerIn": "ScrollReveal-module__Jsyyca__scrollStaggerIn",
  "skill": "ScrollReveal-module__Jsyyca__skill",
  "stagger": "ScrollReveal-module__Jsyyca__stagger",
});
